import { create } from "zustand"

export interface HITLProposal {
  summary: string
  diff: string
  onApprove: () => void
  onReject: (message?: string) => void
  onEditApprove: (editedSummary: string) => void
  onSteer: (steerMessage: string) => void
  onCancel?: () => Promise<void>
  /** Indicates this proposal is likely a retry after a previous approval attempt failed. */
  possibleRetryAfterFailure?: boolean
}

interface HITLStore {
  proposal: HITLProposal | null
  setProposal: (proposal: HITLProposal | null) => void
  /** Set by the reject flow to prompt the user for their next action. */
  showRejectFollowup: boolean
  setShowRejectFollowup: (show: boolean) => void
  /**
   * True between the officer approving an edit and the commit finishing — the
   * approval panel has already closed, so the running banner uses this to say
   * "Applying your edit…" instead of the generic "Revising…".
   */
  isApplying: boolean
  setIsApplying: (applying: boolean) => void
}

export const useHITLStore = create<HITLStore>((set) => ({
  proposal: null,
  setProposal: (proposal) => set({ proposal }),
  showRejectFollowup: false,
  setShowRejectFollowup: (show) => set({ showRejectFollowup: show }),
  isApplying: false,
  setIsApplying: (applying) => set({ isApplying: applying }),
}))
